export default __webpack_public_path__ + "static/9-2--4ca82c371dce10c9e0e39657896d3ce2.png";